import React from 'react';
import { Helmet } from 'react-helmet';

const MetaData = ({ title }) => {
    const site = "Trinket of Treasures";
    const fullTitle = title ? `${site} | ${title}` : site;
    return (
        <Helmet>
            <title>{fullTitle}</title>
        </Helmet>
    );
};

export default MetaData;
